<template>
  <div>
    <el-table :data="value.languages_list">
      <el-table-column :label="$t('Campaign_MultiLanguage_Language')">
        <template slot-scope="scope">
          <el-select
            v-model="value.languages_list[scope.$index]"
            filterable
            :placeholder="$t('Campaign_MultiLanguage_SelectLanguage')"
            @change="onLanguageSelect"
            :disabled="!!variantWinner"
            data-testid="language-selector"
          >
            <el-option
              v-for="(language, code) in filteredLanguages"
              :disabled="value.languages_list.includes(code)"
              :key="code"
              :label="`${language} (${code})`"
              :value="code"
            />
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('Campaign_MultiLanguage_Default')"
        :width="100"
      >
        <template slot-scope="scope">
          <el-radio
            class="radioBtn"
            v-model="value.languages_default"
            :disabled="scope.row === ''"
            :label="scope.row"
          />
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('Campaign_MultiLanguage_RemoveLanguage')"
        :width="100"
      >
        <template slot-scope="scope">
          <div class="iconCt">
            <icon
              v-if="scope.row !== value.languages_default"
              class="icon"
              glyph="bin"
              @click="removeLanguage(scope.$index)"
            />
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-button
      type="primary"
      class="addBtn"
      @click="addLanguage"
      plain
      icon="el-icon-circle-plus-outline"
      :disabled="
        !!variantWinner ||
          value.languages_list[value.languages_list.length - 1] === ''
      "
    >
      {{ $t('Campaign_MultiLanguage_AddLanguage') }}
    </el-button>
  </div>
</template>

<script>
import { languages } from '@/modules/campaign-manage/enum/LanguagesEnum'
import _ from 'lodash'
import { $hasFeature } from '@/core/utils/VueAcl'

export default {
  name: 'MultiLanguageSelector',

  props: {
    value: {
      required: true
    }
  },

  data() {
    return {
      languages
    }
  },

  computed: {
    variantWinner() {
      return this.value.variants.find(variant => variant.winner)
    },
    filteredLanguages() {
      let languages = _.clone(this.languages)
      if (!$hasFeature('allowFiveCharacterLanguageCode')) {
        for (let key of Object.keys(languages)) {
          if (key.length > 2) {
            delete languages[key]
          }
        }
      }

      return languages
    }
  },

  methods: {
    addLanguage() {
      if (
        this.value.languages_list[this.value.languages_list.length - 1] !== ''
      ) {
        this.value.languages_list.push('')
      }
    },

    removeLanguage(index) {
      if (this.variantWinner) {
        return
      }
      if (this.value.languages_list.length > 1) {
        this.value.languages_list.splice(index, 1)
      }
    },

    onLanguageSelect(selection) {
      if (!this.value.languages_list.includes(this.value.languages_default)) {
        this.value.languages_default = selection
      }
    }
  }
}
</script>

<style scoped>
>>> .el-table {
  width: 50%;
  max-width: 800px;
  border: 1px solid #dbdee7;
  border-radius: 4px;
}

>>> .el-table th {
  padding: 12px 0;
  font-family: Open Sans, sans-serif;
  font-size: 14px;
  line-height: 22px;
  font-weight: 600;
  color: #4b515f;
}

>>> .el-table td {
  padding: 4px 0;
}

>>> .el-table th:not(:first-child) {
  text-align: center;
}

>>> .el-radio {
  height: 30px;
  display: flex;
  align-items: center;
}

>>> .el-radio__label {
  display: none;
}

>>> .el-select {
  width: 100%;
}

.iconCt {
  display: flex;
  justify-content: center;
}

.icon {
  display: flex;
  justify-content: center;
  width: 20px;
  height: 20px;
  color: #a7acba;
}

.icon:hover {
  cursor: pointer;
}

.radioBtn {
  display: flex;
  justify-content: center;
}

.addBtn {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/setup/MultiLanguageSelector.vue